<template>
   <!-- style="z-index: 1000;" class="d-flex justify-space-between"-->
  <div >
    <v-dialog transition="dialog-bottom-transition" v-model="openModal" :max-width="width">

      <v-card class="helper-card">
        <v-card-title class="color-v-card-title my-n3">
          <span class="text">{{ helperDetails.title }}</span>
          
          <v-spacer></v-spacer>
          <v-btn @click="openModal = false" icon>
              <v-icon color="white">mdi mdi-close
                </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-4"><span v-html="helperDetails.body"></span></v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
    <a
      @click.prevent="getHelpSystemByUniqueId($event)"
      class="position-relative"
      :data-helper-id="helperId"
    >
      <!-- <div :class="{ 'spinner spinner-primary spinner-sm': sendRequest }">
        <i title="برای راهنمایی بیشتر کلیک  کنید!" style="font-size: x-large;"
          v-if="!sendRequest"
          class="fa fa-exclamation-circle text-primary"
        ></i>
      </div> -->
      <small   class="pt-0">راهنما <v-icon color="primary">mdi-information</v-icon></small>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { RepoFactory } from '@/baseRepository/Factory';
const helpSystemRepository = () => RepoFactory.get('helpSystem');
import Helper from '@/core/helpers';
export default {
  name: 'HelperComponent',
  props: {
    helperId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      openModal: false,
      helperDetails: {
        id: 0,
        title: null,
        body: null,
        helpCategoryId: null,
        helpCategoryTitle: null,
        frontUniqueId: null,
        placeholderText: null,
      },
      sendRequest: false,
    };
  },
  computed: {
    ...mapGetters(['contentBaseUrl', 'taksaanUrl']),
    href() {
      return `${this.taksaanUrl}/${this.helperId}`;
    },
    width() {
      const size = this.helperDetails.placeholderText;
      if (size == 'small') return 400;
      if (size == 'medium') return 500;
      if (size == 'large') return '';
      return 500;
    },
  },
  methods: {
    getHelpSystemByUniqueId() {
      this.sendRequest = true;
      const params = {
        frontUniqueId: this.helperId,
      };
      helpSystemRepository()
        .getHelpSystemByUniqueId(this.contentBaseUrl, params)
        .then((res) => {
          this.helperDetails = res.data;
          this.openModal = true;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        }).finally(() => (this.sendRequest = false))
    },
  },
};
</script>

<style scoped>
.helper-card{

}
.card,
.card-header {
  background-color: white !important;
}
.card-footer {
  border-top: none;
}
.color-v-card-title{
  background-color: rgb(88,103,221);
}
.text{
  color: white;
}
</style>
